export default "__VITE_ASSET__D7Jz1EOZ__"